import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grow shrink self-stretch p-5 md:px-6 md:py-5 bg-racq-anti-flash-white justify-start items-start gap-4 flex flex-col md:flex-row rounded" }
const _hoisted_2 = { class: "grow shrink justify-start items-start gap-4 md:gap-5 flex" }
const _hoisted_3 = { class: "grow shrink flex-col justify-start items-start inline-flex" }

import { Field, RichText, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'CTABanner',
  props: {
    fields: {},
    isButtonDisabled: { type: Boolean }
  },
  emits: ['buttonClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Define Component state
// ------------------------------------------------------------- //
const emit = __emit;

// Functions
// ------------------------------------------------------------- //

const buttonClicked = (values: any) => {
  emit('buttonClicked', values);
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.fields.icon?.value)
        ? (_openBlock(), _createBlock(_unref(Image), {
            key: 0,
            media: _ctx.fields.icon,
            class: "w-12 h-12"
          }, null, 8, ["media"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.fields.title)
          ? (_openBlock(), _createBlock(_unref(RichText), {
              key: 0,
              class: "text-racq-dark-grey text-base-bold",
              field: _ctx.fields.title
            }, null, 8, ["field"]))
          : _createCommentVNode("", true),
        (_ctx.fields.subTitle)
          ? (_openBlock(), _createBlock(_unref(RichText), {
              key: 1,
              class: "text-racq-dark-grey text-m",
              field: _ctx.fields.subTitle
            }, null, 8, ["field"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.fields.buttonText?.value)
      ? (_openBlock(), _createBlock(_component_FormKit, {
          key: 0,
          type: "button",
          label: _ctx.fields.buttonText?.value,
          inputClass: "btn btn-md md:btn-sm btn-secondary w-full md:w-max",
          outerClass: "w-full md:w-max",
          onClick: buttonClicked,
          disabled: _ctx.isButtonDisabled ?? false
        }, null, 8, ["label", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})